import { AntTooltip } from './AntTooltip';

export enum FETCH_STATE {
    FETCHING = 'fetching',
    SUCCESS = 'success',
    ERROR = 'error',
}

export const LoaderWithText: React.FC<{ text: string }> = ({ text }) => {
    return (
        <div className="flex items-center justify-center space-x-10">
            <p>{text}</p>
            <p>
                <svg
                    className="w-16 h-16 fill-textColor-secondary animate-spin"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 512 512"
                >
                    <path d="M96 256c0-26.5-21.5-48-48-48S0 229.5 0 256s21.5 48 48 48S96 282.5 96 256zM108.9 60.89c-26.5 0-48.01 21.49-48.01 47.99S82.39 156.9 108.9 156.9s47.99-21.51 47.99-48.01S135.4 60.89 108.9 60.89zM108.9 355.1c-26.5 0-48.01 21.51-48.01 48.01S82.39 451.1 108.9 451.1s47.99-21.49 47.99-47.99S135.4 355.1 108.9 355.1zM256 416c-26.5 0-48 21.5-48 48S229.5 512 256 512s48-21.5 48-48S282.5 416 256 416zM464 208C437.5 208 416 229.5 416 256s21.5 48 48 48S512 282.5 512 256S490.5 208 464 208zM403.1 355.1c-26.5 0-47.99 21.51-47.99 48.01S376.6 451.1 403.1 451.1s48.01-21.49 48.01-47.99S429.6 355.1 403.1 355.1zM256 0C229.5 0 208 21.5 208 48S229.5 96 256 96s48-21.5 48-48S282.5 0 256 0z"></path>
                </svg>
            </p>
        </div>
    );
};

export const RefreshWithErrorText: React.FC<{ text: string; onRefresh?: () => void }> = ({
    text,
    onRefresh,
}) => {
    return (
        <div className="flex items-center justify-center space-x-10">
            <p>{text}</p>
            {onRefresh && (
                <AntTooltip content="Refresh">
                    <button onClick={onRefresh}>
                        <svg className="w-14 h-14 fill-actionPrimary" viewBox="0 0 512 512">
                            <path d="M370.72 133.28C339.458 104.008 298.888 87.962 255.848 88C178.39 88.068 111.52 141.178 93.057 214.85C91.713 220.213 86.935 224 81.406 224H24.103C16.605 224 10.909 217.193 12.296 209.824C33.933 94.924 134.813 8 256 8C322.448 8 382.791 34.136 427.315 76.685L463.03 40.97C478.149 25.851 504 36.559 504 57.941V192C504 205.255 493.255 216 480 216H345.941C324.559 216 313.851 190.149 328.97 175.029L370.72 133.28V133.28ZM32 296H166.059C187.441 296 198.149 321.851 183.03 336.971L141.28 378.721C172.542 407.994 213.115 424.04 256.156 424.001C333.574 423.931 400.471 370.857 418.943 297.152C420.287 291.789 425.065 288.002 430.594 288.002H487.898C495.396 288.002 501.092 294.809 499.705 302.178C478.067 417.076 377.187 504 256 504C189.552 504 129.209 477.864 84.685 435.315L48.97 471.03C33.851 486.149 8 475.441 8 454.059V320C8 306.745 18.745 296 32 296Z"></path>
                        </svg>
                    </button>
                </AntTooltip>
            )}
        </div>
    );
};
